module.exports = __webpack_public_path__ + "img/Scroll.34432170.png";